import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const opportunityApplicationInterviewService = createApi({
    reducerPath: 'opportunityApplicationInterviewService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['OpportunityApplicationInterview'],
    endpoints: (builder) => ({

        // ⭐ GET ALL PAGINATED WITH SORTING
        getAllOpportunityApplicationInterview: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationInterviewController.getAllOpportunityApplicationInterview}/${body.page}/${body.size}?orderBy=${body.sort}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        // ⭐ GET BY ID
        getOpportunityApplicationInterviewById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationInterviewController.getOpportunityApplicationInterviewById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        // ⭐ SAVE
        saveOpportunityApplicationInterview: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationInterviewController.saveOpportunityApplicationInterview}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,   // JSON or multipart form-data
                };
            }
        }),

        // ⭐ UPDATE
        updateOpportunityApplicationInterview: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationInterviewController.updateOpportunityApplicationInterview}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            }
        }),

        // ⭐ DELETE
        deleteOpportunityApplicationInterview: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationInterviewController.deleteOpportunityApplicationInterview}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        // ⭐ SEARCH
        getAllOpportunityApplicationInterviewBySearch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationInterviewController.getAllOpportunityApplicationInterviewBySearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),

        // ⭐ FIND ALL (NO PAGINATION)
        findAllOpportunityApplicationInterview: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationInterviewController.findAllOpportunityApplicationInterview}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        // ⭐ BULK UPLOAD
        bulkSaveOpportunityApplicationInterview: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationInterviewController.bulkSaveOpportunityApplicationInterview}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload, // multipart/form-data or JSON
                };
            }
        }),
    }),
});

export const {
    useGetAllOpportunityApplicationInterviewMutation,
    useGetOpportunityApplicationInterviewByIdMutation,
    useSaveOpportunityApplicationInterviewMutation,
    useUpdateOpportunityApplicationInterviewMutation,
    useDeleteOpportunityApplicationInterviewMutation,
    useGetAllOpportunityApplicationInterviewBySearchMutation,
    useFindAllOpportunityApplicationInterviewMutation,
    useBulkSaveOpportunityApplicationInterviewMutation
} = opportunityApplicationInterviewService;
